import { GameFormVariant } from '@/components//GameFormVariant';
import {
  CmsAccountPage,
  CmsGamePageVariant,
  CmsLink,
  CmsPage,
} from '@/components/CmsInterfaces';
import GameContainer from '@/components/GameContainer';
import GameProvider from '@/components/GameProvider';
import OfflineInfo from '@/components/OfflineInfo';
import Page from '@/components/Page';
import { getGameById } from '@/helpers/getGameById';
import { getGameByShortname } from '@/helpers/getGameByShortname';
import { getGameSwitchList } from '@/helpers/getGameLink';
import { getVariantOfGamePage } from '@/helpers/getVariantOfGamePage';

export interface PageGameProps extends CmsPage {
  title: string;
  game: string;
  gameEurojackpot?: CmsGamePageVariant;
  gameGluecksspirale?: CmsGamePageVariant;
  gameKeno?: CmsGamePageVariant;
  gameLotto6aus49?: CmsGamePageVariant;
  canonical?: CmsLink;
  seoHeadline?: string;
  seoDescription?: string;
}

class PageGame extends Page<PageGameProps> {
  public render(): JSX.Element {
    const { game: id, seoDescription, seoHeadline } = this.props;
    const game =
      (id && getGameByShortname(id.toLowerCase())) || getGameById(id);
    const variant = getVariantOfGamePage(this.props);
    const loginPageData: CmsAccountPage = {
      path: '/login',
      variant: GameFormVariant.Login,
    };

    return (
      <GameProvider>
        {game && (
          // @ts-expect-error GameContainer's connected props (selectedPlayNumber, crossedNumbers, etc.) come from redux via connect(), not from this component's own props
          <GameContainer
            {...{ ...game, seoHeadline, seoDescription }}
            iframe={variant === CmsGamePageVariant.IFrame}
            external={variant === CmsGamePageVariant.External}
            gameGluecksspirale={variant}
            loginPagePath={loginPageData && loginPageData.path}
            gameSwitch={getGameSwitchList()}
          />
        )}
        <OfflineInfo />
      </GameProvider>
    );
  }
}

export default PageGame;
